import { render, staticRenderFns } from "./AddAnimalEn.vue?vue&type=template&id=2220bf24&"
import script from "./AddAnimalEn.vue?vue&type=script&lang=js&"
export * from "./AddAnimalEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports